import React from 'react'
import { View, Image, TouchableOpacity } from 'react-native'
import Swiper from 'react-native-web-swiper'
import Icon from 'react-native-vector-icons/Feather'
import tw from 'tailwind-rn'
import { HGText } from '../HGUI'
import styles from './styles'

type ImageSliderItem = {
  imageUrl: string
  title: string
  description: string
  image?: unknown
}

type Props = {
  sliderData: Array<ImageSliderItem>
}

const ImageSlider = (props: Props) => {
  const { sliderData } = props

  return (
    <View style={[styles.sliderImageContainer, tw('bg-gray-700 rounded-xl')]}>
      <Swiper
        // loop
        innerContainerStyle={
          {
            // paddingBottomq: 100,
          }
        }
        from={0}
        minDistanceForAction={0.1}
        springConfig={{ bounciness: 0 }}
        controlsProps={{
          dotsWrapperStyle: {
            bottom: 0,
          },
          dotsTouchable: true,
          prevPos: 'left',
          nextPos: 'right',
          NextComponent: ({ onPress }) => (
            <TouchableOpacity
              style={[styles.buttonContainerRight]}
              onPress={onPress}
            >
              <Icon
                name="chevron-right"
                size={40}
                style={[styles.button, styles.buttonNext]}
              />
            </TouchableOpacity>
          ),
          PrevComponent: ({ onPress }) => (
            <TouchableOpacity
              onPress={onPress}
              style={[styles.buttonContainerLeft]}
            >
              <Icon
                name="chevron-left"
                size={40}
                style={[styles.button, styles.buttonPrev]}
              />
            </TouchableOpacity>
          ),
        }}
      >
        {sliderData.map(({ title, description, image, imageUrl }) => (
          <View key={imageUrl} style={tw('flex-1 w-full h-5/6 items-center')}>
            <View style={tw('flex-1 w-full')}>
              <Image
                source={image || { uri: imageUrl }}
                style={{
                  resizeMode: 'contain',
                  width: '100%',
                  height: '100%',
                }}
              />
            </View>

            <View style={tw('mb-10 mt-2 px-5 w-full')}>
              <HGText style={[styles.description, styles.title]}>
                {title}
              </HGText>
              <HGText style={[styles.description, styles.subtitle]}>
                {description}
              </HGText>
            </View>
          </View>
        ))}
      </Swiper>
    </View>
  )
}

export default ImageSlider
